import { styled } from "@mui/material";
import React from "react";

const LoadingOverlay = () => {
  return (
    <Letters>
      <Circle1>
        <Circle2>
          <Circle3 />
        </Circle2>
      </Circle1>
    </Letters>
  );
};

export default LoadingOverlay;

const circleStyles = `
    display: block;
    border-left: 5px solid;
    border-top-left-radius: 100%;
    border-top: 5px solid;
    margin: 5px;
    animation-name: Loader_611;
    animation-duration: 1500ms;
    animation-timing-function: linear;
    animation-delay: 0s;
    animation-iteration-count: infinite;
    animation-direction: normal;
    animation-fill-mode: forwards;

`;

const Circle1 = styled("span")`
  ${circleStyles}
  border-left-color: var(--m-color-blue-03);
  border-top-color: var(--m-color-blue-03);
  width: 40px;
  height: 40px;
`;

const Circle2 = styled("span")`
  ${circleStyles}
  border-left-color: var(--m-color-red-01);
  border-top-color: var(--m-color-red-01);
  width: 30px;
  height: 30px;
`;

const Circle3 = styled("div")`
  ${circleStyles}
  width: 20px;
  height: 20px;
  border-left-color: var(--m-color-gray-02);
  border-top-color: var(--m-color-gray-02);
`;

const Letters = styled("div")`
  display: flex;
  justify-content: center;
  padding-right: 30px;
`;
